import PropTypes from "prop-types";
import useLanguageChange from "../../hooks/useLanguageChange";
import CenterModal from "../UI/Modal/CenterModal";

const DownloadChatNotSupportedModal = ({ isDownloadNotAvailable, handleCloseModal }) => {
    const localisedValues = useLanguageChange();

    const modalHeader = (
        <>
            <h5 className='modal-title'>{localisedValues["message_title"]}</h5>
            <button type='button' className='btn-close' aria-label='Close' onClick={handleCloseModal}>
                <span className='btn-icon icon-close-light'></span>
            </button>
        </>
    );

    const modalBody = (
        <div className='cms-modal-text'>
            <p>{localisedValues["download_not_supported_text"]}</p>
        </div>
    );

    const modalFooter = (
        <div className='button-inline more-space button-inline-tb-space d-flex align-items-center'>
            <div className='button'>
                <button className='btn default-btn-link' onClick={() => handleCloseModal()}>
                    {localisedValues["okay_cap"]}
                </button>
            </div>
        </div>
    );

    return (
        <CenterModal
            showModal={isDownloadNotAvailable}
            closeModal={() => handleCloseModal()}
            modalClass='default-modal modal-small mob-bottom-top'
            bodyClassName='default-custom-scroll'
            className='modal-dialog-centered'
            header={modalHeader}
            body={modalBody}
            footer={modalFooter}
            backdrop={"static"}
        />
    );
};

DownloadChatNotSupportedModal.propTypes = {
    isDownloadNotAvailable: PropTypes.bool,
    handleCloseModal: PropTypes.func,
};

export default DownloadChatNotSupportedModal;
